import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { showSuccessSnackbar } from 'hooks/useSnackbar';
import { accountIdSelector } from 'store/user/selectors';
import axiosApi from 'utils/axios';

import { SaveInfoForLaterMutationReq } from '../../types';

export const useDefaultValuesMutation = () => {
  const accountId = useSelector(accountIdSelector);

  return useMutation({
    mutationFn: ({ eventType, defaultValues, pageId, pageName, wholeTeam }: SaveInfoForLaterMutationReq) =>
      axiosApi.post(`/acc/${accountId}/trip_event_default_values`, {
        eventType,
        defaultValues,
        pageId,
        pageName,
        wholeTeam,
      }),
    onSuccess: () => {
      showSuccessSnackbar('Information saved for later');
    },
  });
};
